import Text from 'src/components/Text/Text';
import Switch from 'src/components/Switch';
import Tooltip from '../Tooltip/Tooltip';
import { Info } from '@drift-labs/icons';
import Select from '../Inputs/Select';
import { useState } from 'react';

interface MarginUpdateRowProps {
	label: string;
	marginEnabledChecked: boolean;
	currentMaxLev: number | undefined;
	dlpAutoDerisk: boolean;
	onChangeEnabled: (newValue: boolean) => void;
	onChangeRatio: (newValue: number | undefined) => void;
	onChangeDlpAutoDerisk: (newValue: boolean) => void;
	disabled?: boolean;
	spacedOut?: boolean;
	includeLineSpace?: boolean;
	textClass?: string;
	tooltipText?: string;
}

const MarginUpdateRow = ({
	label,
	marginEnabledChecked,
	currentMaxLev,
	dlpAutoDerisk,
	onChangeEnabled,
	onChangeRatio,
	onChangeDlpAutoDerisk,
	disabled,
	spacedOut = true,
	textClass,
	tooltipText,
}: MarginUpdateRowProps) => {
	// const [selection, setSelection] = useState(currentMaxLev);
	const [marginEnabledSelection, setMarginEnabledSelection] =
		useState(marginEnabledChecked);

	const [dlpAutoDeriskSelection, setDlpAutoDeriskSelection] =
		useState(dlpAutoDerisk);

	return (
		<div
			key={label}
			className={`grid grid-cols-4 w-full space-x-1 flex items-center ${
				spacedOut ? 'justify-between' : 'gap-2'
			} ${disabled ? 'mb-4' : 'mb-2'}`}
		>
			<div className="col-span-1">
				{tooltipText ? (
					<Tooltip
						className={`inline-flex items-center ${
							textClass ? textClass : 'text-text-label'
						}`}
						content={tooltipText}
					>
						<Text.BODY2>{label}</Text.BODY2>
						<Info className={`ml-1`} size={12} />
					</Tooltip>
				) : (
					<div>
						<Text.BODY2
							className={`${textClass ? textClass : 'text-text-label'}`}
						>
							{label}
						</Text.BODY2>
					</div>
				)}
			</div>
			<Switch
				className="col-span-1"
				checked={marginEnabledSelection}
				disabled={disabled}
				onChange={(value: boolean) => {
					setMarginEnabledSelection(value);
					onChangeEnabled(value);
				}}
			/>

			<div className="col-span-1">
				{disabled ? (
					<Text.BODY2 className="text-text-secondary">
						{currentMaxLev ? `${currentMaxLev}x` : 'None'}
					</Text.BODY2>
				) : (
					<Select.MaxLeverageSelector
						onChange={onChangeRatio}
						initialSelection={currentMaxLev}
					/>
					// <Select.Default
					// 	id="max_lev_selector"
					// 	className="w-[100px]"
					// 	selection={selection}
					// 	options={MAX_LEVERAGE_OPTIONS}
					// 	onChange={(value: number | undefined) => {
					// 		setSelection(value);
					// 		onChangeRatio(value);
					// 	}}
					// />
				)}
			</div>

			<Switch
				className="justify-end col-span-1"
				checked={dlpAutoDeriskSelection}
				disabled={disabled}
				onChange={(value: boolean) => {
					setDlpAutoDeriskSelection(value);
					onChangeDlpAutoDerisk(value);
				}}
			/>
		</div>
	);
};

export default MarginUpdateRow;
